import React from 'react';
import { FieldMetaState, useField } from 'react-final-form';

type WhenProps = {
  field: string;
  is?:
    | string
    | boolean
    | ((value: HTMLInputElement['value'], meta: FieldMetaState<HTMLInputElement>) => boolean);
  children: React.ReactNode;
  subscription?: { value: boolean };
};

const When: React.FC<WhenProps> = ({
  field,
  children,
  subscription = {
    value: true,
  },
  is = true,
}) => {
  const { input, meta } = useField(field, { subscription });

  if (typeof is === 'function') {
    return is(input.value, meta) ? children : null;
  }
  return input.value === is ? children : null;
};

export default When;
